import { Action, initialState, State } from "store/store";

export const removeBlockLocal = (
  state: State = initialState,
  { data }: Action
): State => {
  const nextState = {
    ...state,
    blocks: { ...state.blocks },
  };

  delete nextState.blocks[data.id];

  return nextState;
};